import { render, staticRenderFns } from "./CiudadPage.vue?vue&type=template&id=ba666760"
import script from "./CiudadPage.js?vue&type=script&lang=js&external"
export * from "./CiudadPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports